import { auth } from "./app.js";
import { routes, findRouteMatch } from "../routes.js";

const auths = () => {
    if (auth.currentUser) {
      console.log("In auth user", auth.currentUser);
    }
};

export const hasRole = (role, requiredRole) => {
  const roles = ["executor", "viewer", "manager", "designer", "admin", "superuser"];

  const index = roles.indexOf(role);
  const requiredIndex = roles.indexOf(requiredRole);

  if (index === -1 || requiredIndex === -1) return false;

  return index >= requiredIndex;
};

export const findRequiredRole = (route) => {
  const match = findRouteMatch(routes, route);
  return match?.role;
};

export default auths;